import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { memo, useEffect, useMemo } from "react";
import { useFormik, Form, FormikProvider, FastField } from "formik";
import { useSelector } from "react-redux";
import GlobalSelectField from "../../../../mui/GlobalSelectField";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import {
  clearDistrict,
  clearstate,
  getDistrictPreData,
  getStatePreData,
  updateLead,
} from "../../../../../redux/features/generalSlice";
import { useSnackbar } from "notistack";
import useResponsive from "../../../../../Hooks/useResponsive";

const genderOptions = [
  { id: "Male", name: "Male" },
  { id: "Female", name: "Female" },
];

const CustomTextField = ({ name, label, disabled, action, ...props }) => {
  return (
    <FastField name={name}>
      {({ field, meta }) => (
        <TextField
          key={name}
          {...field}
          label={label}
          fullWidth
          disabled={disabled}
          onChange={action}
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
          {...props}
        />
      )}
    </FastField>
  );
};

const StudentEditForm = memo(({ open }) => {
  const smUp = useResponsive("up", "sm");
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const {
    classPreData,
    syllabusPredata,
    mediums,
    LeadEdit,
    localBodies,
    country,
    state,
    district,
    leadUpdateloading,
    availableCourse,
  } = useSelector((state) => ({
    classPreData: state.assessmentTool.classPreData,
    syllabusPredata: state.assessmentTool.syllabusPredata,
    mediums: state.cro.mediums,
    LeadEdit: state.ogd.LeadEdit,
    localBodies: state.general.localBodies,
    country: state.general.country,
    state: state.general.state,
    district: state.general.district,
    leadUpdateloading: state.general.leadUpdateloading,
    availableCourse: state.courses.availableCourse,
  }));

  const profile = useMemo(() => {
    return JSON.parse(localStorage.getItem("cred"))?.profile || {};
  }, []);

  const isOga = useMemo(
    () =>
      profile.role === "Operations Growth Associate" && profile.roleID === 18,
    [profile]
  );

  const formik = useFormik({
    enableReinitialize: false,
    initialValues: {
      name: LeadEdit.name || "",
      admnNo: LeadEdit.admnNo,
      classId: parseInt(LeadEdit.classId) || "",
      contactPerson: LeadEdit.contactPerson || "",
      relationWithStudent: LeadEdit.relationWithStudent || "",
      countryCode: LeadEdit.countryCode || "",
      mobNo: LeadEdit.mobNo || "",
      emailId: LeadEdit.emailId || "",
      place: LeadEdit.place || "",
      localBody: LeadEdit.localBody || "",
      district: LeadEdit.district || "",
      state: parseInt(LeadEdit.state) || "",
      country: LeadEdit.country || "",
      syllabus: LeadEdit.syllabus || "",
      mediumId: LeadEdit.mediumId || "",
      completedCourse: LeadEdit.completedCourse || "",
      source: LeadEdit.source || "",
      school: LeadEdit.school || "",
      placeOfSchool: LeadEdit.placeOfSchool || "",
      fatherName: LeadEdit.fatherName || "",
      fatherOccupation: "",
      motherName: LeadEdit.motherName || "",
      motherOccupation: "",
      aboutFamily: LeadEdit.aboutFamily || "",
      studentHobbiesInterest: LeadEdit.studentHobbiesInterest || "",
      previousTuitionHistory: LeadEdit.previousTuitionHistory || "",
      remarks: LeadEdit.remarks || "",
      dob: LeadEdit.dob || "",
      gender: LeadEdit.gender || "",
      houseName: LeadEdit.houseName || "",
      landmark: LeadEdit.landmark || "",
      street: LeadEdit.street || "",
      cityTown: LeadEdit.cityTown || "",
      post: LeadEdit.post || "",
      pincode: LeadEdit.pincode || "",
      leadId: LeadEdit.leadId || "",
      bookAndPublications: "",
      enrolledCourses: LeadEdit.enrolledCourses || [],
    },
    // validationSchema: Schema,
    onSubmit: (values) => {
      dispatch(updateLead(values)).then((res) => {
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
        } else if (
          res.payload.status === "failed" ||
          res.payload.status === "error"
        ) {
          enqueueSnackbar(res.payload.message, { variant: "error" });
        }
      });
    },
  });

  useEffect(() => {
    if (open) {
      if (formik.values.country) {
        dispatch(getStatePreData(formik.values.country));
      } else {
        formik.setFieldValue("state", null);
        formik.setFieldValue("district", null);
        dispatch(clearstate());
        dispatch(clearDistrict());
      }

      if (formik.values.state) {
        dispatch(getDistrictPreData(formik.values.state));
      } else {
        formik.setFieldValue("district", null);
        dispatch(clearDistrict());
      }
    }
  }, [open, formik.values.country, formik.values.state, dispatch]);

  return (
    <Box padding={3}>
      {open ? (
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Stack direction={smUp ? "row" : "column"} spacing={2}>
              <CustomTextField
                // disabled={LeadEdit?.enrolledCourses?.length > 0 ? true : false}
                name={"name"}
                label={"Name"}
                formik={formik}
                action={formik.handleChange}
              />
              <CustomTextField
                disabled={LeadEdit?.enrolledCourses?.length > 0 ? true : false}
                name={"contactPerson"}
                label={"Contact Person"}
                formik={formik}
              />
              <CustomTextField
                name={"relationWithStudent"}
                label={"Relation With Student"}
                formik={formik}
              />
            </Stack>
            <Stack direction={smUp ? "row" : "column"} spacing={2} mt={2}>
              <CustomTextField
                name={"countryCode"}
                label={"Country Code"}
                formik={formik}
                disabled={true}
              />
              <CustomTextField
                name={"mobNo"}
                label={"Mobile No"}
                formik={formik}
                disabled={true}
              />
              <CustomTextField
                disabled={LeadEdit?.enrolledCourses?.length > 0 ? true : false}
                name={"emailId"}
                label={"Email Id"}
                formik={formik}
              />
            </Stack>
            <Stack direction={smUp ? "row" : "column"} spacing={2} mt={2}>
              <CustomTextField name={"place"} label={"place"} formik={formik} />

              <GlobalSelectField
                options={{
                  formik: formik,
                  label: "LocalBody",
                  name: "localBody",
                  data: localBodies,
                  keys: {
                    id: "localBodyId",
                    value: "localBodyName",
                  },
                  sx: {
                    width: "100%",
                  },
                }}
              />
              <CustomTextField
                name={"completedCourse"}
                label={"Completed Course"}
                formik={formik}
                disabled={true}
              />
            </Stack>

            <Stack direction={smUp ? "row" : "column"} spacing={2} mt={2}>
              <Autocomplete
                disablePortal
                options={country}
                getOptionLabel={(option) => option.countryName}
                sx={{ width: "100%" }}
                value={
                  formik.values.country
                    ? country?.find(
                        (item) => item.countryId === formik.values.country
                      )
                    : null
                }
                onChange={(e, option, value) => {
                  formik.setFieldValue(
                    "country",
                    option ? option.countryId : null
                  );
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Country" />
                )}
              />
              <Autocomplete
                disablePortal
                options={state}
                getOptionLabel={(option) => option.stateName}
                sx={{ width: "100%" }}
                value={
                  state?.find((item) => item.stateId === formik.values.state) ||
                  null
                }
                onChange={(e, option, value) => {
                  formik.setFieldValue("state", option ? option.stateId : null);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="State" />
                )}
              />

              <Autocomplete
                disablePortal
                options={district}
                getOptionLabel={(option) => option.districtName}
                sx={{ width: "100%" }}
                value={
                  district?.find(
                    (item) => item.districtId === formik.values.district
                  ) || null
                }
                onChange={(e, option, value) => {
                  formik.setFieldValue(
                    "district",
                    option ? option.districtId : null
                  );
                }}
                renderInput={(params) => (
                  <TextField {...params} label="District" />
                )}
              />
            </Stack>

            <Stack direction={smUp ? "row" : "column"} spacing={2} pt={2}>
              <GlobalSelectField
                options={{
                  formik: formik,
                  label: "Syllabus",
                  name: "syllabus",
                  data: syllabusPredata,
                  keys: {
                    id: "id",
                    value: "name",
                  },
                  sx: {
                    width: "100%",
                  },
                }}
              />
              <GlobalSelectField
                options={{
                  formik: formik,
                  label: "Class",
                  name: "classId",
                  data: classPreData,
                  keys: {
                    id: "id",
                    value: "className",
                  },
                  sx: {
                    width: "100%",
                  },
                }}
              />
              <GlobalSelectField
                options={{
                  formik: formik,
                  label: "Medium",
                  name: "mediumId",
                  data: mediums,
                  keys: {
                    id: "id",
                    value: "name",
                  },
                  sx: {
                    width: "100%",
                  },
                }}
              />
            </Stack>
            <Stack direction={smUp ? "row" : "column"} spacing={2} mt={2}>
              <CustomTextField
                name={"source"}
                label={"Source"}
                formik={formik}
                disabled={true}
              />
              <CustomTextField
                name={"school"}
                label={"School"}
                formik={formik}
              />
              <CustomTextField
                name={"placeOfSchool"}
                label={"Place Of School"}
                formik={formik}
              />
            </Stack>
            <Stack direction={smUp ? "row" : "column"} spacing={2} mt={2}>
              <CustomTextField
                name={"fatherName"}
                label={"Father Name"}
                formik={formik}
              />
              <CustomTextField
                name={"fatherOccupation"}
                label={"Father Occupation"}
                formik={formik}
              />
              <CustomTextField
                name={"motherName"}
                label={"Mother Name"}
                formik={formik}
              />
            </Stack>
            <Stack direction={smUp ? "row" : "column"} spacing={2} mt={2}>
              <CustomTextField
                name={"motherOccupation"}
                label={"Mother Occupation"}
                formik={formik}
              />
              <CustomTextField
                name={"aboutFamily"}
                label={"About Family"}
                formik={formik}
              />
              <CustomTextField
                name={"studentHobbiesInterest"}
                label={"Student Hobbies Interest"}
                formik={formik}
              />
            </Stack>

            <Stack direction={smUp ? "row" : "column"} spacing={2} mt={2}>
              <CustomTextField
                name={"previousTuitionHistory"}
                label={"Previous Tuition History"}
                formik={formik}
                multiline
                rows={3}
              />
              <CustomTextField
                name={"remarks"}
                label={"Remarks"}
                formik={formik}
                multiline
                rows={3}
              />
            </Stack>
            <Stack direction={smUp ? "row" : "column"} spacing={2} mt={2}>
              <CustomTextField
                name={"landmark"}
                label={"Landmark"}
                formik={formik}
              />
              <CustomTextField
                name={"street"}
                label={"Street"}
                formik={formik}
              />
              <CustomTextField
                name={"cityTown"}
                label={"City Town"}
                formik={formik}
              />
            </Stack>

            <Stack direction={smUp ? "row" : "column"} spacing={2} mt={2}>
              <CustomTextField name={"post"} label={"Post"} formik={formik} />
              <CustomTextField
                name={"pincode"}
                label={"Pincode"}
                formik={formik}
              />
              <CustomTextField
                name={"location"}
                label={"Location"}
                formik={formik}
              />
            </Stack>

            <Stack direction={smUp ? "row" : "column"} spacing={2} pt={2}>
              <CustomTextField
                name={"houseName"}
                label={"House Name"}
                formik={formik}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Date Of Birth"
                  value={dayjs(formik.values.dob)}
                  sx={{ width: "100%" }}
                  onChange={(newValue) => {
                    formik.setFieldValue(
                      "dob",
                      dayjs(newValue).format("YYYY-MM-DD")
                    );
                  }}
                />
              </LocalizationProvider>
              <GlobalSelectField
                options={{
                  formik: formik,
                  label: "Gender",
                  name: "gender",
                  data: genderOptions,
                  keys: {
                    id: "id",
                    value: "name",
                  },
                  sx: {
                    width: "100%",
                  },
                }}
              />
            </Stack>
            <Stack direction={smUp ? "row" : "column"} spacing={2} mt={2}>
              <CustomTextField
                name={"bookAndPublications"}
                label={"Book And Publications"}
                formik={formik}
                multiline
                rows={3}
              />
            </Stack>
            {/* -------------------------------------------------------------------- */}
            <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
              <Typography variant="h4">Course Enrollment</Typography>
            </Box>

            {formik.values.enrolledCourses.map((item, index) => {
              return (
                <Box>
                  <Divider
                    sx={{
                      mt: 2,
                      borderStyle: "dashed",
                      borderBottomWidth: 3,
                      backgroundColor: "balck",
                    }}
                  />
                  <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                    <Chip
                      variant="contained"
                      icon={
                        <Icon
                          icon="material-symbols-light:other-admission-outline-rounded"
                          width="24"
                          height="24"
                        />
                      }
                      color="primary"
                      label={
                        formik.values.enrolledCourses[index]?.cartItemId == null
                          ? "LeadSquared Enrollment"
                          : "Cart Enrollment"
                      }
                    />
                  </Box>
                  <Stack direction={smUp ? "row" : "column"} spacing={2} mt={2}>
                    <Autocomplete
                      disablePortal
                      options={availableCourse}
                      getOptionLabel={(option) =>
                        option && option.courseName ? option.courseName : ""
                      }
                      value={
                        availableCourse.find(
                          (course) =>
                            course.id ===
                            formik.values.enrolledCourses[index].courseId
                        ) || null
                      }
                      onChange={(e, option) =>
                        formik.setFieldValue(
                          `enrolledCourses[${index}].courseId`,
                          option ? option.id : ""
                        )
                      }
                      sx={{ width: "100%" }}
                      renderInput={(params) => (
                        <TextField {...params} label="Course Name" />
                      )}
                    />
                    <FastField name={`enrolledCourses[${index}].leadRemarks`}>
                      {({ field }) => (
                        <TextField
                          {...field}
                          label="Lead Remarks"
                          fullWidth
                          multiline
                          rows={3}
                        />
                      )}
                    </FastField>
                  </Stack>

                  <Stack direction={smUp ? "row" : "column"} spacing={2} mt={2}>
                    <FastField
                      name={`enrolledCourses[${index}].subjectSessionRemarks`}
                    >
                      {({ field }) => (
                        <TextField
                          {...field}
                          label="Subject Session Remarks"
                          fullWidth
                          multiline
                          rows={3}
                        />
                      )}
                    </FastField>
                  </Stack>
                  <Stack direction={smUp ? "row" : "column"} spacing={2} mt={2}>
                    <FastField name={`enrolledCourses[${index}].feeperSession`}>
                      {({ field }) => (
                        <TextField
                          {...field}
                          label="Fee per Session"
                          fullWidth
                          disabled
                        />
                      )}
                    </FastField>
                    {/* ------------------------------------------------------------- */}
                    <FastField name={`enrolledCourses[${index}].totalSesion`}>
                      {({ field, form }) => (
                        <TextField
                          {...field}
                          label="Total Session"
                          fullWidth
                          onChange={(e) => {
                            const totalSesion = e.target.value;
                            form.setFieldValue(field.name, totalSesion);

                            // Calculate fee per session
                            const totalFees =
                              form.values.enrolledCourses[index]?.totalFees ||
                              0;
                            if (totalFees && totalSesion) {
                              form.setFieldValue(
                                `enrolledCourses[${index}].feeperSession`,
                                (totalFees / totalSesion).toFixed(2)
                              );
                            }
                          }}
                        />
                      )}
                    </FastField>

                    <FastField name={`enrolledCourses[${index}].totalFees`}>
                      {({ field, form }) => (
                        <TextField
                          {...field}
                          label="Total Fees"
                          fullWidth
                          onChange={(e) => {
                            const totalFees = e.target.value;
                            form.setFieldValue(field.name, totalFees);

                            // Calculate fee per session
                            const totalSesion =
                              form.values.enrolledCourses[index]?.totalSesion ||
                              0;
                            if (totalFees && totalSesion) {
                              form.setFieldValue(
                                `enrolledCourses[${index}].feeperSession`,
                                (totalFees / totalSesion).toFixed(2)
                              );
                            }
                          }}
                        />
                      )}
                    </FastField>
                    {/* ------------------------------------------------------------- */}
                  </Stack>
                  <Stack direction={smUp ? "row" : "column"} spacing={2} mt={2}>
                    <FastField name={`enrolledCourses[${index}].timePreferred`}>
                      {({ field }) => (
                        <TextField
                          {...field}
                          multiline
                          rows={3}
                          label="Time Preferred"
                          fullWidth
                        />
                      )}
                    </FastField>
                  </Stack>
                  <Stack direction={smUp ? "row" : "column"} spacing={2} mt={2}>
                    <FormControl fullWidth>
                      <InputLabel id={`trainer-select-label-${index}`}>
                        Trainer Preferred
                      </InputLabel>
                      <Select
                        labelId={`trainer-select-label-${index}`}
                        label="Trainer Preferred"
                        id={`trainer-select-${index}`}
                        value={
                          formik.values.enrolledCourses[index]
                            .trainerpreferred || ""
                        }
                        onChange={(e) =>
                          formik.setFieldValue(
                            `enrolledCourses[${index}].trainerpreferred`,
                            e.target.value
                          )
                        }
                      >
                        <MenuItem value="Male">Male</MenuItem>
                        <MenuItem value="Female">Female</MenuItem>
                      </Select>
                    </FormControl>
                    <FastField name={`enrolledCourses[${index}].classperWeek`}>
                      {({ field }) => (
                        <TextField
                          {...field}
                          label="Class Per Week"
                          fullWidth
                        />
                      )}
                    </FastField>
                    <FastField
                      name={`enrolledCourses[${index}].admissionFreeStatus`}
                    >
                      {({ field }) => (
                        <TextField
                          {...field}
                          label="Admission Free Status"
                          fullWidth
                        />
                      )}
                    </FastField>
                  </Stack>
                  <Stack direction={smUp ? "row" : "column"} spacing={2} mt={2}>
                    <FastField
                      name={`enrolledCourses[${index}].admissionFeeReason`}
                    >
                      {({ field }) => (
                        <TextField
                          {...field}
                          label="Admission Fee Reason"
                          fullWidth
                          multiline
                          rows={3}
                        />
                      )}
                    </FastField>

                    <FastField name={`enrolledCourses[${index}].publication`}>
                      {({ field }) => (
                        <TextField
                          {...field}
                          label="Publication"
                          fullWidth
                          multiline
                          rows={3}
                        />
                      )}
                    </FastField>
                  </Stack>
                </Box>
              );
            })}

            {isOga ? null : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  pt: 2,
                  position: "sticky",
                  bottom: 0,
                  background: "transparent",
                  zIndex: 1000,
                  pb: 2,
                }}
              >
                <Button
                  disabled={leadUpdateloading}
                  sx={{
                    background: "linear-gradient(to right, #a125c2, #000000)",
                    color: "white",
                    borderRadius: 3,
                    width: "30%",
                  }}
                  type="submit"
                >
                  {leadUpdateloading ? (
                    <Icon
                      icon="line-md:loading-twotone-loop"
                      width="24"
                      height="24"
                    />
                  ) : (
                    <Icon icon="radix-icons:update" width="20" height="20" />
                  )}
                  {leadUpdateloading ? "Please wait..." : "Update"}
                </Button>
              </Box>
            )}
          </Form>
        </FormikProvider>
      ) : null}
    </Box>
  );
});

export default StudentEditForm;
